const IS_MAC =
  (typeof navigator !== 'undefined' && navigator.userAgent.includes('Macintosh')) || false;

// Some keyboard events have lame key descriptions like `ArrowLeft` that we want
// to remap to a symbol.  If key is in this table, it will be remapped.
export const KEY_DESCRIPTIONS: { [code: string]: string | undefined } = {
  mod: IS_MAC ? '⌘' : 'Ctrl',
  shift: 'Shift',
  ctrl: IS_MAC ? '⌃' : 'Ctrl',
  alt: IS_MAC ? '⌥' : 'Alt',
  option: IS_MAC ? '⌥' : 'Alt',
  meta: IS_MAC ? '⌘' : 'Win',
  command: IS_MAC ? '⌘' : 'Win',
  backspace: 'Backspace',
  tab: 'Tab',
  enter: 'Enter',
  return: 'Return',
  capslock: 'Capslock',
  esc: 'Esc',
  escape: 'Escape',
  space: 'Space',
  pageup: 'PgUp',
  pagedown: 'PgDown',
  end: 'End',
  home: 'Home',
  left: '←',
  up: '↑',
  right: '→',
  down: '↓',
  ins: 'Insert',
  del: 'Delete',
  plus: '+',
};
